import React, { useState, useEffect } from "react";

// @material-ui/icons
import { Switch, Tooltip } from "@material-ui/core";
import { Assignment } from "components/MaterialSymbol/MaterialIcons";
import { Edit } from "components/MaterialSymbol/MaterialIcons";
import { Close } from "components/MaterialSymbol/MaterialIcons";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Modal from "components/Modal/Modal.js";
import Notification from "components/Notification/Notification.js";
import AreYouSure from "components/AreYouSure/AreYouSure";
import UserMenu from "components/UserMenu/UserMenu.js";

// custom components
import CreateUser from "./CreateUser.js";

import UserService from "../../services/UserService";
import PasswordManagement from "components/PasswordManagement/PasswordManagement.js";
import FormattedDate from "components/FormattedDate/FormattedDate.js";
import { safeParseList } from "helpers";


export const CREATE_USER = {
    title: "Create user",
    successMessage: "user created successfully",
};

export const EDIT_USER = {
    title: "Edit user",
    successMessage: "user updated successfully",
};

const ADMIN_ROLE = 1;

export default function Users() {
    const [open, setOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [form, setForm] = useState(CREATE_USER);
    const [openModal, setOpenModal] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [notification, setNotification] = useState({
        open: false,
        color: "success",
    });

    //

    useEffect(() => {
        const getUsers = async () => {
            const response = await UserService.getAll();
            const users = response.data.map((user) => ({
                ...user,
                managedDomains: safeParseList(user.managedDomains),
            }));

            setUsers(users);
        };
        getUsers();
    }, []);

    const onSuccess = (user) => {
        if (form === CREATE_USER) {
            setUsers([...users, user]);
        }

        if (form === EDIT_USER) {
            const nUsers = users.map((c) => (c.id === user.id ? { ...c, ...user } : c));
            setUsers(nUsers);
        }

        setInitialValues({});
        setOpenModal(false);
        setNotification({
            ...notification,
            open: true,
            message: form.successMessage,
        });
    };

    const deleteUser = async (userId) => {
        await UserService.del(userId);
    };

    return (
        <>
            {notification.open && (
                <Notification
                    open={notification.open}
                    color={notification.color}
                    message={notification.message}
                />
            )}

            <Modal open={openModal} modalTitle={form.title} handleClose={setOpenModal}>
                <CreateUser
                    form={form}
                    initialValues={initialValues}
                    onSuccess={(user) => onSuccess(user)}
                />
            </Modal>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <Button
                                color="primary"
                                onClick={() => {
                                    setForm(CREATE_USER);
                                    setOpenModal(true);
                                    setInitialValues({});
                                }}
                            >
                                Create user
                            </Button>
                        </CardHeader>
                        <CardBody>
                            <ReactTable
                                columns={[
                                    {
                                        Header: "Id",
                                        accessor: "id",
                                    },
                                    {
                                        Header: "First name",
                                        accessor: "firstName",
                                    },
                                    {
                                        Header: "Last name",
                                        accessor: "lastName",
                                    },
                                    {
                                        Header: "Email",
                                        accessor: "email",
                                    },
                                    {
                                        Header: "Role",
                                        accessor: "role",
                                    },
                                    {
                                        Header: "Created at",
                                        Cell: ({
                                            row: {
                                                original: { createdAt },
                                            },
                                        }) => {
                                            return <FormattedDate date={createdAt} />;
                                        },
                                    },
                                    {
                                        Header: "Updated at",
                                        Cell: ({
                                            row: {
                                                original: { updatedAt },
                                            },
                                        }) => {
                                            return <FormattedDate date={updatedAt} />;
                                        },
                                    },
                                    /*{
                                        Header: "Created at",
                                        accessor: "createdAt",
                                    },
                                    {
                                        Header: "Updated at",
                                        accessor: "updatedAt",
                                    },*/
                                    {
                                        Header: "Actions",
                                        Cell: (props) => {
                                            const rowIdx = props.row.id;
                                            const user = users[rowIdx];

                                            return (
                                                <>
                                                    <div className="actions-right">
                                                        <Button
                                                            justIcon
                                                            round
                                                            simple
                                                            color="warning"
                                                            className="edit"
                                                            onClick={() => {
                                                                setForm(EDIT_USER);
                                                                setOpenModal(true);
                                                                setInitialValues(user);
                                                            }}
                                                        >
                                                            <Edit />
                                                        </Button>
                                                        <Tooltip
                                                            title={
                                                                "When the switch is on, this means the user is still active; if the switch is off, the user is inactive."
                                                            }
                                                        >
                                                            <Switch
                                                                size="small"
                                                                checked={user.isDeleted === 0}
                                                                onChange={async (e) => {
                                                                    if (e.target.checked) {
                                                                        await UserService.enableUser(
                                                                            user.id
                                                                        );
                                                                    } else {
                                                                        await UserService.del(
                                                                            user.id
                                                                        );
                                                                    }

                                                                    const nUsers = users.map((c) =>
                                                                        c.id === user.id
                                                                            ? {
                                                                                ...c,
                                                                                isDeleted: !c.isDeleted,
                                                                            }
                                                                            : c
                                                                    );
                                                                    setUsers(nUsers);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        {/*<UserMenu
                                                            isDeleted={user.isDeleted}
                                                            userId={user.id}
                                                            handleChange={() => {
                                                                const nUsers = users.map((c) =>
                                                                    c.id === user.id
                                                                        ? {
                                                                              ...c,
                                                                              isDeleted: !c.isDeleted,
                                                                          }
                                                                        : c
                                                                );
                                                                setUsers(nUsers);
                                                            }}
                                                        />*/}
                                                        <PasswordManagement
                                                            userId={user.id}
                                                            userType="USER"
                                                            userName={user.email}
                                                        />
                                                        {/*<Button
                                                            justIcon
                                                            round
                                                            simple
                                                            color="danger"
                                                            className="edit"
                                                            onClick={() => {
                                                                setInitialValues(user);
                                                                setOpen(true);
                                                            }}
                                                            disabled={user.roleId == ADMIN_ROLE}
                                                        >
                                                            <Close />
                                                        </Button>*/}
                                                    </div>
                                                </>
                                            );
                                        },
                                    },
                                ]}
                                data={users}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            <AreYouSure
                open={open}
                title={`Are you sure?`}
                subtitle={`The record will be deleted`}
                onAccept={async () => {
                    await UserService.del(initialValues.id);
                    setUsers([...users].filter((user) => user.id !== initialValues.id));
                    setOpen(false);
                }}
                onCancel={() => setOpen(false)}
            />
        </>
    );
}
